/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React, { Component } from 'react';
import { Row, Col, Button, Input } from 'reactstrap';
import {
  RichTextEditorComponent,
  HtmlEditor,
  Table,
  Inject,
  Toolbar,
  Link,
  Image,
  QuickToolbar,
} from '@syncfusion/ej2-react-richtexteditor';
import Spinners from '../../../components/Spinners/Spinners';
import { uacService } from '../../../services/uac.service';
import axios from 'axios';
import './Submit.scss';

class Submit extends Component {
  constructor(props) {
    super(props);
    let shortId;
    let participantShortId;
    try {
      // Try to get search from props.location first, then fallback to window.location
      let search = this.props.location?.search || '';

      // If not available in props, try to extract from window.location (for HashRouter)
      if (!search && typeof window !== 'undefined') {
        // For HashRouter, the URL format is #/upload?0uynpaa95
        const hash = window.location.hash || '';
        const hashMatch = hash.match(/\?([^#]*)/);
        if (hashMatch) {
          search = '?' + hashMatch[1];
        } else {
          // Fallback to window.location.search
          search = window.location.search || '';
        }
      }

      if (search) {
        // Remove the '?' prefix if present
        const queryString = search.startsWith('?') ? search.slice(1) : search;

        if (queryString.length === 15) {
          // If length is 15 (after removing '?'), split into shortId (11 chars) and participantShortId (4 chars)
          shortId = queryString.slice(0, 11);
          participantShortId = queryString.slice(11, 15);
        } else if (queryString.length > 0) {
          // Otherwise, use the entire query string as shortId
          shortId = queryString;
          participantShortId = '';
        }
      } else {
        console.warn('No search string found in URL');
      }
    } catch (e) {
      console.warn('Error parsing location search:', e);
    }
    this.state = {
      shortId,
      participantShortId,
      message: '',
      response: {
        type: -1,
      },
      newAttachmentList: [],
      newAttachmentDataList: [],
      createAttachmentDataList: [],
      createActivityAttachmentList: [],
      showLoader: true,
      open: -1,
      formInputs: [],
      guestEmail: '',
      guestMessage: '',
      guestName: '',
      sampleTestingDocsObj: {},
      logoBase64: '',
    };

    this.items = [
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      'LowerCase',
      'UpperCase',
      '|',
      'Formats',
      'Alignments',
      'OrderedList',
      'UnorderedList',
      'Outdent',
      'Indent',
      '|',
      'CreateTable',
      'CreateLink',
      'Image',
      '|',
      'Undo',
      'Redo',
    ];
    this.toolbarSettings = {
      items: this.items,
      type: 'MultiRow',
    };

    this.uploadAttachments = this.uploadAttachments.bind(this);
    this.onCreateRemoveAttachment = this.onCreateRemoveAttachment.bind(this);
    this.saveNewAttachment = this.saveNewAttachment.bind(this);
    this.uploadChatAttachment = this.uploadChatAttachment.bind(this);
    this.toggle = this.toggle.bind(this);
    this.getDataFromTxt = this.getDataFromTxt.bind(this);
    this.updateFilesData = this.updateFilesData.bind(this);
    this.addFilesData = this.addFilesData.bind(this);
    this.createSubject = this.createSubject.bind(this);
    this.createMailBody = this.createMailBody.bind(this);
  }

  successMsg = (successMessage, docList, isSampleTesting) => {
    let attachmentList = docList.filter((data) => data?.filesData?.length > 0);

    let newAttachmentListObj = {};
    attachmentList.forEach((doc) => {
      newAttachmentListObj = {
        ...newAttachmentListObj,
        [doc?.displayName]: [],
      };
      newAttachmentListObj = {
        ...newAttachmentListObj,
        [doc.displayName]: attachmentList?.filter(
          (innerDoc) => doc.displayName === innerDoc.displayName
        ),
      };
    });
    return isSampleTesting ? (
      <div className="uploadMsgSuccess">
        <div
          dangerouslySetInnerHTML={{ __html: successMessage }}
          className="messageListTitle"
        ></div>
        {Object.keys(newAttachmentListObj)?.map((doc, index) => {
          const key = index;
          return (
            <div key={key}>
              <span className="requestedDocsDisplayName">{doc}-</span>
              {newAttachmentListObj[doc]?.map((participant) => {
                return (
                  <div className="requestedDocs" key={key}>
                    <span className="requestedDocsLabel">{participant.label}-</span>
                    {participant?.filesData?.length > 1 ? (
                      <ol>
                        {participant?.filesData?.map((file, index) => {
                          const ind = index;
                          return <li key={ind}>{this.getFileDisplayName(file?.Key)}</li>;
                        })}
                      </ol>
                    ) : (
                      <p className="singleFileUploaded">
                        {participant?.filesData?.map((file, index) => {
                          const ind = index;
                          return <span key={ind}>{this.getFileDisplayName(file?.Key)}</span>;
                        })}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
        <p className="uploadMsgDefaultText">
          Your Auditor will contact you in case of any queries.
        </p>
      </div>
    ) : (
      <div className="uploadMsgSuccess">
        <div
          dangerouslySetInnerHTML={{ __html: successMessage }}
          className="messageListTitle"
        ></div>
        {attachmentList?.map((doc, index) => {
          const key = index;
          return doc?.filesData?.length > 1 ? (
            <div className="requestedDocs" key={key}>
              <span>{doc?.label}-</span>
              <ol>
                {doc?.filesData?.map((file, index) => {
                  const ind = index;
                  return <li key={ind}>{this.getFileDisplayName(file?.Key)}</li>;
                })}
              </ol>
            </div>
          ) : (
            <div className="requestedDocs" key={key}>
              <span>{doc?.label}-</span>
              <p className="singleFileUploaded">
                {doc?.filesData?.map((file, index) => {
                  const ind = index;
                  return <span key={ind}>{this.getFileDisplayName(file?.Key)}</span>;
                })}
              </p>
            </div>
          );
        })}
        <p className="uploadMsgDefaultText">
          Your Auditor will contact you in case of any queries.
        </p>
      </div>
    );
  };

  toggle(id) {
    if (this.state.open === id) {
      this.setState({ open: -1 });
    } else {
      this.setState({ open: id });
    }
  }

  componentDidMount() {
    const { shortId } = this.state;
    this.fetchShortURLData(shortId);
  }

  fetchShortURLData(shortId) {
    if (!shortId) {
      return;
    }

    uacService
      .postUacUrlShortner({ type: 'get', shortURL: shortId })
      .then((data) => {
        if (!data) {
          this.setErrorState('Uh oh. The link is not valid(4004).');
          return;
        }
        let payload;
        try {
          payload =
            typeof data.body === 'string'
              ? JSON.parse(data.body)
              : data.body && typeof data.body === 'object'
                ? data.body
                : data;
        } catch (e) {
          this.setErrorState('Uh oh. The link is not valid(4003).');
          return;
        }
        if (!payload) {
          this.setErrorState('Uh oh. The link is not valid(4004).');
          return;
        }
        if (payload.success === false) {
          this.setErrorState('Uh oh. The link is not valid(4005).');
          return;
        }
        this.handleShortURLPayload(payload);
      })
      .catch(() => {
        this.setErrorState('Uh oh. The link is not valid(4004).');
      });
  }

  handleShortURLPayload(jsonBody) {
    try {
      const { downloadURL, uploadURL } = this.extractURLs(jsonBody);

      if (!downloadURL || typeof downloadURL !== 'string') {
        this.setErrorState('Uh oh. The link is not valid(4006).');
        return;
      }

      this.setState({ uploadURL, downloadURL });
      this.fetchDownloadData(downloadURL);
    } catch (e) {
      this.setErrorState('Uh oh. The link is not valid(4003).');
    }
  }

  extractURLs(jsonBody) {
    if (jsonBody['url']) {
      return this.parseURLFromParams(jsonBody.url);
    } else {
      return {
        uploadURL: jsonBody['uploadURL'],
        downloadURL: jsonBody['downloadURL'],
      };
    }
  }

  parseURLFromParams(url) {
    try {
      const params = JSON.parse(atob(url.split('upload?')[1]));

      if (!(params?.a && params?.b && params?.c && params?.c && params?.d)) {
        this.setErrorState('Uh oh. The link is not valid(4001).');
        return { downloadURL: '', uploadURL: '' };
      }

      return this.buildS3URLs(params);
    } catch {
      this.setErrorState('Uh oh. The link is not valid(4000).');
      return { downloadURL: '', uploadURL: '' };
    }
  }

  buildS3URLs(params) {
    const fileName = params['a'];
    const d_Credential = encodeURIComponent(params['b']);
    const d_Date = params['c'];
    const d_Signature = params['d'];
    const u_Signature = params['e'];
    const d_Security_Token = encodeURIComponent(params['f']);
    const bucketType = params['g'];

    const baseURL = 'https://' + process.env.AWS_USER_FILES_S3_BUCKET + '.s3.amazonaws.com/uac/';

    const downloadURL =
      baseURL +
      fileName +
      '.txt?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=' +
      d_Credential +
      '&X-Amz-Date=' +
      d_Date +
      '&X-Amz-Security-Token=' +
      d_Security_Token +
      '&X-Amz-Expires=86400&X-Amz-Signature=' +
      d_Signature +
      '&X-Amz-SignedHeaders=host';

    const uploadURL =
      baseURL +
      fileName +
      '.txt?Content-Type=text/plain&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=' +
      d_Credential +
      '&X-Amz-Date=' +
      d_Date +
      '&X-Amz-Security-Token=' +
      d_Security_Token +
      '&X-Amz-Expires=86400&X-Amz-Signature=' +
      u_Signature +
      '&X-Amz-SignedHeaders=host';

    return { downloadURL, uploadURL };
  }

  fetchDownloadData(downloadURL) {
    if (!downloadURL || typeof downloadURL !== 'string') {
      return;
    }
    fetch(downloadURL)
      .then((response) => response.text())
      .then((txt) => this.processDownloadData(txt))
      .catch((err) => {
        console.warn('Error in promise chain:', err);
      });
  }

  processDownloadData(txt) {
    this.setState({ txtResponse: txt.replace(/####/g, '##') }, () => {
      try {
        const replacedTxt = txt.replace(/####/g, '##');
        let metadata = JSON.parse(replacedTxt.split('###')[1]);
        const tempSampleTestingObj = this.buildSampleTestingObj(metadata);

        metadata = this.getDataFromTxt(true, 1);
        const newRequestedDocs = metadata?.requestedDocs;
        const updateInState = this.buildUpdateState(txt, metadata, newRequestedDocs);

        this.setState({
          sampleTestingDocsObj: tempSampleTestingObj,
          ...updateInState,
        });

        this.checkForExpiredURL(metadata);
      } catch (e) {
        this.setErrorState('Uh oh. The link is not valid(4002).');
      }
    });
  }

  buildSampleTestingObj(metadata) {
    let tempSampleTestingObj = {};

    if (metadata?.docRequestType === 'sample_testing') {
      metadata?.requestedDocs?.forEach((doc) => {
        Object.keys(doc?.attributes)?.forEach((attr) => {
          metadata?.auditTest?.forEach((auditObj) => {
            auditObj?.attributes?.forEach((auditAttrObj) => {
              if (
                auditAttrObj?.groupAbbreviationId === attr &&
                doc?.attributes[attr]?.sample &&
                doc?.attributes[attr]?.client
              ) {
                tempSampleTestingObj = {
                  ...tempSampleTestingObj,
                  [attr]: { ...auditObj },
                };
              }
            });
          });
        });
      });
    }

    return tempSampleTestingObj;
  }

  buildUpdateState(txt, metadata, newRequestedDocs) {
    const updateInState = {
      metadata: {
        ...metadata,
        requestedDocs: newRequestedDocs
          .filter((doc) => !doc.isSubmitted)
          .filter((doc) => !doc.docReceived),
      },
      cpaName: metadata?.routingInfo?.cpaName || '',
      cpaId: metadata?.cpaId || metadata?.routingInfo?.cpaId || 'AUT',
      planName: metadata?.planName,
      displayMessage: txt
        .replace(/####/g, '##')
        .split('###')[2]
        .replace(/\n/g, ' ')
        .replace(/\\n/g, '')
        .replace(/\\/g, ''),
      successMessage: txt.replace(/####/g, '##').split('###')[3].replace(/\n/g, ' '),
      failureMessage: txt.replace(/####/g, '##').split('###')[4].replace(/\n/g, ' '),
      logoBase64: this.getDataFromTxt(false, 5),
      showLoader: false,
    };

    const cpaLogoReplaceValue = updateInState.logoBase64
      ? '<img alt="CPA Firm Logo" height="40" src="' + updateInState.logoBase64 + '" />'
      : '';

    updateInState.displayMessage = updateInState.displayMessage.replaceAll(
      '{{cpa_logo}}',
      cpaLogoReplaceValue
    );
    updateInState.successMessage = updateInState.successMessage.replaceAll(
      '{{cpa_logo}}',
      cpaLogoReplaceValue
    );
    updateInState.failureMessage = updateInState.failureMessage.replaceAll(
      '{{cpa_logo}}',
      cpaLogoReplaceValue
    );

    return updateInState;
  }

  checkForExpiredURL(metadata) {
    if (metadata?.requestedDocs.length === 0) {
      this.setState({
        response: {
          type: 0,
          isBrokenLink: true,
          title: 'URL has expired',
          message: 'Please contact Administrator. If you did not expect this message',
        },
      });
    }
  }

  setErrorState(title) {
    this.setState({
      showLoader: false,
      response: {
        type: 0,
        isBrokenLink: true,
        title: title,
        message: 'Please contact Administrator. If you did not expect this message',
      },
    });
  }

  uploadAttachments(files, docId) {
    let { newAttachmentList, newAttachmentDataList } = this.state;
    files.forEach((file) => {
      let fileKey = `${new Date().getTime()}_${file.name}`;
      newAttachmentList.push({
        displayName: file.name,
        name: this.fileNameWithTimeStamp(file.name),
        key: fileKey,
        docId: docId,
      });
      newAttachmentDataList.push({
        file: file,
        key: fileKey,
        docId: docId,
      });
    });
    this.setState({
      newAttachmentList: newAttachmentList,
      newAttachmentDataList: newAttachmentDataList,
    });
  }

  /** Folder under "Sample Testing/" — same string as the section heading (e.g. "Hiring Documents"). */
  getSampleTestingSectionFolderName(docIndex) {
    const { metadata, sampleTestingDocsObj } = this.state;
    if (metadata?.docRequestType !== 'sample_testing' || docIndex == null || docIndex < 0) {
      return '';
    }
    const doc = metadata?.requestedDocs?.[docIndex];
    if (!doc?.attributes) return '';
    for (const attr of Object.keys(doc.attributes)) {
      const folderName = sampleTestingDocsObj[attr]?.displayName;
      if (folderName) return folderName;
    }
    return '';
  }

  getDocIndexForAttachmentId(docId) {
    const { metadata } = this.state;
    if (!docId || !metadata?.requestedDocs) return undefined;
    const idx = metadata.requestedDocs.findIndex((doc) =>
      doc.filesData?.some((f) => f.Id === docId)
    );
    return idx >= 0 ? idx : undefined;
  }

  getS3KeyPrefix(docIndex) {
    const cpaId =
      this.state?.cpaId ||
      this.state?.metadata?.cpaId ||
      this.state?.metadata?.routingInfo?.cpaId ||
      'AUT';
    const planName = this.state?.planName || this.state?.metadata?.planName || 'Unknown';
    // No leading slash — backend may prepend "uac/"; leading slash caused double slash (uac//AUT/...)
    const base = `CPADocuments/${cpaId}/401K/2025/${planName}/Sample Testing/`;
    const sectionFolder = this.getSampleTestingSectionFolderName(docIndex);
    return sectionFolder ? `${base}${sectionFolder}/` : base;
  }

  fileNameWithTimeStamp(fileName) {
    let timeStamp = new Date().getTime();
    let newArray = fileName.split('.');
    let newFileName = '';
    newArray.forEach((eachString, i) => {
      if (i == 0) {
        newFileName = eachString + '_' + timeStamp;
      } else {
        newFileName = newFileName + '.' + eachString;
      }
    });
    return newFileName;
  }

  getFileDisplayName(key) {
    if (!key) return '';
    const filename = key.includes('/') ? key.split('/').pop() : key;
    return filename.replace(/_\d+\./, '.');
  }

  onCreateRemoveAttachment(doc) {
    let { newAttachmentList, newAttachmentDataList } = this.state;
    let listIndex = newAttachmentList.findIndex((item) => item.key === doc.key);
    newAttachmentList.splice(listIndex, 1);
    let dataIndex = newAttachmentDataList.findIndex((item) => item.key === doc.key);
    newAttachmentDataList.splice(dataIndex, 1);
    this.setState({
      newAttachmentList,
      newAttachmentDataList,
    });
  }

  saveNewAttachment(index) {
    const { newAttachmentDataList, newAttachmentList } = this.state;
    if (this.state.guestName == undefined || this.state.guestName == '') {
      this.setState({ errorMessage: 'Please enter your name' });
      return;
    }
    if (
      !(
        this.state.guestEmail &&
        this.state.guestEmail != '' &&
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.guestEmail)
      )
    ) {
      this.setState({ errorMessage: 'Please enter your email' });
      return;
    }
    if (newAttachmentDataList.length == 0) {
      this.setState({ errorMessage: 'Please attach file(s)' });
      return;
    }
    this.setState({ errorMessage: '' });
    this.setState({ showLoader: true });
    let { createAttachmentDataList, createActivityAttachmentList } = this.state;
    newAttachmentDataList.forEach((item) => {
      createAttachmentDataList.push(item);
    });
    newAttachmentList.forEach((item) => {
      createActivityAttachmentList.push(item);
    });
    this.setState(
      {
        newAttachmentList: [],
        newAttachmentDataList: [],
        createAttachmentDataList,
        createActivityAttachmentList,
      },
      () => {
        this.uploadChatAttachment(1, index);
      }
    );
  }

  uploadChatAttachment(attempts) {
    const { createAttachmentDataList } = this.state;
    let { metadata } = this.state;

    try {
      const filesData = this.buildFilesData(createAttachmentDataList);
      const jsonData = this.buildJsonData(metadata, filesData);
      this.uploadInitialData(jsonData);

      if (filesData.length === 0) {
        return;
      }

      this.processFileUploads(attempts, createAttachmentDataList);
    } catch {
      this.handleUploadError(createAttachmentDataList, metadata);
    }
  }

  buildFilesData(createAttachmentDataList) {
    const filesData = [];
    for (let attachment of createAttachmentDataList) {
      const docIndex = this.getDocIndexForAttachmentId(attachment.docId);
      const key =
        this.getS3KeyPrefix(docIndex) + this.fileNameWithTimeStamp(attachment.file.name);
      filesData.push({
        Id: attachment.docId,
        Key: key,
        ContentType: attachment.file.type,
      });
    }
    return filesData;
  }

  buildJsonData(metadata, filesData) {
    metadata['flag'] = filesData.length > 0 ? 'open' : 'upload';
    delete metadata['urls'];
    delete metadata['filesData'];

    const { requestedDocs } = metadata;

    const tempDocs = requestedDocs.map((doc) => {
      // Match files from filesData to this doc by checking if filesData[].Id exists in doc.filesData[].Id
      const docFileIds = (doc.filesData || []).map((f) => f.Id).filter(Boolean);
      const matchingFilesData = filesData.filter((fd) => docFileIds.includes(fd.Id));

      // Use matching files from buildFilesData (correct S3 Keys), or fallback to existing doc.filesData
      const mergedFilesData =
        matchingFilesData.length > 0
          ? matchingFilesData
          : doc.filesData && doc.filesData.length > 0
            ? doc.filesData.filter((fileData) => Object.keys(fileData).length > 0)
            : [];

      const hasFiles = mergedFilesData.length > 0;
      return {
        ...doc,
        filesData: hasFiles ? mergedFilesData : doc.filesData,
        timestamp: Math.round(new Date().getTime() / 1000),
        isSubmitted: hasFiles,
        isUploaded: false,
        ...(hasFiles && {
          guestEmail: this.state.guestEmail?.trim(),
          guestName: this.state.guestName,
          guestMessage: this.state.guestMessage,
        }),
      };
    });

    return {
      ...metadata,
      requestedDocs: tempDocs,
      source: window.location.host,
    };
  }

  uploadInitialData(jsonData) {
    const { displayMessage, successMessage, failureMessage, logoBase64, uploadURL } = this.state;
    const file = new Blob(
      [
        '###' +
          JSON.stringify(jsonData).replace(/'/g, '#$#$#$#$#$') +
          '###' +
          displayMessage +
          '###' +
          successMessage +
          '###' +
          failureMessage +
          '###' +
          logoBase64 +
          '###',
      ],
      { type: 'text/plain' }
    );

    const body = new FormData();
    body.append('file', file);

    fetch(uploadURL, { method: 'PUT', body })
      .then((success) => this.handleInitialUploadResponse(success))
      .catch(() => this.handleInitialUploadError());
  }

  handleInitialUploadResponse(success) {
    const { createAttachmentDataList, successMessage, failureMessage } = this.state;
    const { metadata } = this.state;

    if (success.status === 200) {
      this.setState({
        response: {
          type: 1,
          title:
            createAttachmentDataList.length > 1
              ? 'Documents Submitted Successfully'
              : 'Document Submitted Successfully',
          message: this.successMsg(
            successMessage,
            metadata?.requestedDocs,
            metadata?.docRequestType === 'sample_testing'
          ),
        },
      });
    } else {
      this.setState({
        showLoader: false,
        response: {
          type: 0,
          title:
            createAttachmentDataList.length > 1
              ? 'Documents Upload Failed'
              : 'Document Upload Failed',
          message: this.successMsg(
            failureMessage,
            metadata?.requestedDocs,
            metadata?.docRequestType === 'sample_testing'
          ),
        },
      });
    }
  }

  handleInitialUploadError() {
    const { createAttachmentDataList, failureMessage } = this.state;
    const { metadata } = this.state;

    this.setState({
      showLoader: false,
      response: {
        type: 0,
        title:
          createAttachmentDataList.length > 1
            ? 'Documents Upload Failed'
            : 'Document Upload Failed',
        message: this.successMsg(
          failureMessage,
          metadata?.requestedDocs,
          metadata?.docRequestType === 'sample_testing'
        ),
      },
    });
  }

  processFileUploads(attempts, createAttachmentDataList) {
    const { downloadURL } = this.state;

    setTimeout(() => {
      fetch(downloadURL, { cache: 'no-store' })
        .then((response) => response.text())
        .then((txt) => this.processDownloadResponse(txt, attempts, createAttachmentDataList))
        .catch((err) => {
          console.warn('Error in promise chain:', err);
        });
    }, 10000);
  }

  processDownloadResponse(txt, attempts, createAttachmentDataList) {
    this.setState({ txtResponse: txt }, () => {
      try {
        const metadata = this.parseMetadataFromTxt(txt);
        this.setState({ metadata });

        const presignedURLs = this.extractPresignedURLs(metadata);

        if (presignedURLs && presignedURLs.length > 0) {
          this.uploadFilesToPresignedURLs(presignedURLs, createAttachmentDataList);
        } else if (attempts >= 3) {
          this.handleMaxAttemptsReached(createAttachmentDataList);
        } else {
          this.uploadChatAttachment(attempts + 1);
        }
      } catch {
        this.handleDownloadProcessingError(createAttachmentDataList);
      }
    });
  }

  parseMetadataFromTxt(txt) {
    if (txt.includes('####')) {
      const replacedTxt = txt.replace(/####/g, '##');
      return JSON.parse(replacedTxt.split('###')[1]);
    } else {
      const data = JSON.parse(JSON.stringify(txt.split('###')[1].replace(/'/g, '')));
      return JSON.parse(data);
    }
  }

  extractPresignedURLs(metadata) {
    let presignedURLs = [];
    if (metadata?.requestedDocs) {
      try {
        metadata?.requestedDocs.forEach((doc, index) => {
          presignedURLs = metadata?.requestedDocs[index].urls
            ? [...presignedURLs, ...doc.urls]
            : [...presignedURLs];
        });
      } catch (error) {
        console.warn('Error processing requested docs:', error);
      }
    }
    return presignedURLs;
  }

  uploadFilesToPresignedURLs(presignedURLs, createAttachmentDataList) {
    const promises = presignedURLs.map((presignedObj) =>
      this.createUploadPromise(presignedObj, createAttachmentDataList)
    );

    Promise.all(promises).then((res) => {
      const result = res.every((r) => r);
      this.handleUploadCompletion(result, createAttachmentDataList);
    });
  }

  createUploadPromise(presignedObj, createAttachmentDataList) {
    return new Promise((resolve, reject) => {
      try {
        const formData = new FormData();
        Object.keys(presignedObj.url.fields).forEach((key) => {
          formData.append(key, presignedObj.url.fields[key]);
        });

        const file = createAttachmentDataList.filter((d) => d.docId === presignedObj.docId)[0].file;
        formData.append('file', file);

        const uploadUrl = presignedObj.url?.url || presignedObj.url;
        axios
          .post(uploadUrl, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(() => resolve({ success: true }))
          .catch((error) => reject({ success: false, error }));
      } catch (e) {
        console.warn('Error in file upload:', e);
        reject({ success: false, error: e });
      }
    });
  }

  handleUploadCompletion(result, createAttachmentDataList) {
    const { metadata, displayMessage, successMessage, failureMessage, logoBase64, uploadURL } =
      this.state;

    this.updateMetadataAfterUpload(metadata);
    this.uploadFinalMetadata(
      metadata,
      displayMessage,
      successMessage,
      failureMessage,
      logoBase64,
      uploadURL
    );

    this.setState({
      showLoader: false,
      response: {
        type: result ? 1 : 0,
        title: result
          ? createAttachmentDataList.length > 1
            ? 'Documents Submitted Successfully'
            : 'Document Submitted Successfully'
          : createAttachmentDataList.length > 1
            ? 'Documents Upload Failed'
            : 'Document Upload Failed',
        message: result
          ? this.successMsg(
              successMessage,
              metadata?.requestedDocs,
              metadata?.docRequestType === 'sample_testing'
            )
          : this.successMsg(
              failureMessage,
              metadata?.requestedDocs,
              metadata?.docRequestType === 'sample_testing'
            ),
      },
      newAttachmentList: [],
      newAttachmentDataList: [],
      createAttachmentDataList: [],
      createActivityAttachmentList: [],
    });
  }

  updateMetadataAfterUpload(metadata) {
    const exactUploadTimestamp = new Date().getTime();
    metadata?.requestedDocs.forEach((doc, index) => {
      if (
        metadata?.requestedDocs[index].filesData &&
        metadata?.requestedDocs[index].filesData.length > 0
      ) {
        metadata.requestedDocs[index]['isUploaded'] = true;
        metadata.requestedDocs[index]['exactUploadTimestamp'] = exactUploadTimestamp;
      }
    });
    metadata['flag'] = 'upload';
  }

  uploadFinalMetadata(
    metadata,
    displayMessage,
    successMessage,
    failureMessage,
    logoBase64,
    uploadURL
  ) {
    const jsonData = { ...metadata };
    const file = new Blob(
      [
        '###' +
          JSON.stringify(jsonData).replace(/##/g, '####').replace(/'/g, '#$#$#$#$#$') +
          '###' +
          displayMessage +
          '###' +
          successMessage +
          '###' +
          failureMessage +
          '###' +
          logoBase64 +
          '###',
      ],
      { type: 'text/plain' }
    );

    const body = new FormData();
    body.append('file', file);

    fetch(uploadURL, { method: 'PUT', body: body }).catch((e) => {
      console.warn('File upload failed:', e);
    });
  }

  handleMaxAttemptsReached(createAttachmentDataList) {
    const { failureMessage } = this.state;
    const { metadata } = this.state;

    this.setState({
      showLoader: false,
      response: {
        type: 0,
        title:
          createAttachmentDataList.length > 1
            ? 'Documents Upload Failed'
            : 'Document Upload Failed',
        message: this.successMsg(
          failureMessage,
          metadata?.requestedDocs,
          metadata?.docRequestType === 'sample_testing'
        ),
      },
    });
  }

  handleDownloadProcessingError(createAttachmentDataList) {
    const { failureMessage } = this.state;
    const { metadata } = this.state;

    this.setState({
      showLoader: false,
      response: {
        type: 0,
        title:
          createAttachmentDataList.length > 1
            ? 'Documents Upload Failed'
            : 'Document Upload Failed',
        message: this.successMsg(
          failureMessage,
          metadata?.requestedDocs,
          metadata?.docRequestType === 'sample_testing'
        ),
      },
    });
  }

  handleUploadError(createAttachmentDataList, metadata) {
    this.setState(prevState => ({
      showLoader: false,
      response: {
        type: 0,
        title:
          createAttachmentDataList.length > 1
            ? 'Documents Upload Failed'
            : 'Document Upload Failed',
        message: this.successMsg(
          prevState.failureMessage,
          metadata?.requestedDocs,
          metadata?.docRequestType === 'sample_testing'
        ),
      },
    }));
  }

  getDataFromTxt(isJSON, index) {
    const { txtResponse } = this.state;
    try {
      if (isJSON) {
        const splitResponse = JSON.stringify(txtResponse).split('###');
        if (splitResponse[index]) {
          return JSON.parse(
            splitResponse[index]
              .replaceAll('\\n', '\\n')
              .replace(/\\t/g, '\\t')
              .replace(/'/g, '"')
              .replace(/[\\]/g, '')
              .replace(/True/g, 'true')
              .replace(/False/g, 'false')
          );
        }
        return null;
      } else return JSON.stringify(txtResponse).split('###')[index];
    } catch {
      try {
        const replacedTxt = txtResponse.replace(/####/g, '##').replace(/\\"/g, '\\"');
        return JSON.parse(replacedTxt.split('###')[1]);
      } catch (error_) {
        console.warn('Error parsing JSON:', error_);
      }
    }
  }

  updateFilesData(e, index) {
    const crypto = window.crypto || window.msCrypto;
    let array = new Uint32Array(1);
    const docId = (crypto.getRandomValues(array)[0] + 1).toString(36).substring(7);
    this.uploadAttachments([e.target.files[0]], docId);
    let docsArr = [...(this.state.metadata?.requestedDocs || [])];
    if (!docsArr[index]?.filesData) {
      docsArr.splice(index, 1, {
        ...docsArr[index],
        filesData: [],
      });
    }
    if (docsArr[index]?.filesData) {
      docsArr[index].filesData.splice(docsArr[index].filesData.length - 1, 1);
    }
    docsArr.splice(index, 1, {
      ...docsArr[index],
      filesData: [
        ...docsArr[index].filesData,
        {
          Id: docId,
          Key: this.getS3KeyPrefix(index) + this.fileNameWithTimeStamp(e.target.files[0].name),
          ContentType: e.target.files[0].type,
        },
      ],
    });
    this.setState((prevState) => ({
      metadata: {
        ...prevState.metadata,
        requestedDocs: docsArr,
      },
    }));
  }

  addFilesData(docIndex) {
    let docsArr = [...(this.state.metadata?.requestedDocs || [])];
    if (
      this.state.metadata?.requestedDocs?.[docIndex]?.filesData?.filter((doc) => !doc.Id).length > 0
    )
      return;
    docsArr.splice(docIndex, 1, {
      ...docsArr[docIndex],
      filesData: [...docsArr[docIndex].filesData, {}],
    });
    this.setState((prevState) => ({
      metadata: {
        ...prevState.metadata,
        requestedDocs: docsArr,
      },
    }));
  }

  handleDocDelete = (file, docIndex) => {
    let { metadata, newAttachmentList, newAttachmentDataList } = this.state;
    let { requestedDocs } = metadata;
    requestedDocs.splice(docIndex, 1, {
      ...requestedDocs[docIndex],
      filesData: requestedDocs[docIndex].filesData.filter((data) => data.Id !== file.Id),
    });
    newAttachmentList = newAttachmentList.filter((data) => data.docId !== file.Id);
    newAttachmentDataList = newAttachmentDataList.filter((data) => data.docId !== file.Id);
    if (requestedDocs.filesData && requestedDocs.filesData.length === 0)
      delete requestedDocs.filesData;
    this.setState({
      metadata,
      newAttachmentList,
      newAttachmentDataList,
    });
  };

  createSubject(docName, participantName) {
    return `Subject: Request for Employee Specific Document ${docName} - ${participantName}`;
  }

  createMailBody(docName, participantName, senderName, shortId) {
    return `Dear ${participantName},

    I hope this email finds you well. As part of the 401K audit we request your assistance in providing document(s) required for the audit process.

    To upload documents, please visit:  ${window.location.href + shortId}

    Your prompt attention to this request is greatly appreciated.

    If you have any questions or require any further information regarding this request. Please feel free to reach out to me.

    Thanks!!`;
  }

  render() {
    const {
      uploadURL,
      downloadURL,
      guestMessage,
      response,
      showLoader,
      displayMessage,
      errorMessage,
      metadata,
      logoBase64,
      sampleTestingDocsObj,
      participantShortId,
    } = this.state;
    let requestedDocs;
    if (metadata?.requestedDocs)
      requestedDocs = metadata['requestedDocs']
        ?.filter((doc) => {
          if (participantShortId) {
            return doc.shortId === participantShortId;
          } else {
            return doc;
          }
        })
        .filter((doc) => !doc.isSubmitted)
        .filter((doc) => !doc.docReceived);
    return (
      <div>
        <div className="submitFormWrapper">
          {showLoader ? (
            <Spinners />
          ) : (
            <form className="submitForm" id="submitForm">
              <div
                className="form-row form-group submitFormInner"
                style={{ backgroundColor: '#333333' }}
              >
                <div className="login-label submitHeader">
                  <div className="cpaImageSection">
                    <img src={logoBase64} alt="cpa logo" />
                  </div>
                  <div className="logoHeader">
                    <p>Powered By</p>
                    <img style={{ width: '125px' }} src="images/logo1.svg" />
                  </div>
                </div>
              </div>
              <div id="outer">
                {uploadURL && downloadURL && response.type == -1 ? (
                  requestedDocs && requestedDocs.length > 0 ? (
                    <div className="submitFormOuter">
                      <div className="submitFormTitle">
                        <h2>UPLOAD YOUR DOCUMENTS</h2>
                      </div>
                      <div
                        className="uploadDocumentsHeading"
                        dangerouslySetInnerHTML={{
                          __html: displayMessage || '',
                        }}
                      ></div>
                      <div className="contentWrapper">
                        <Row className="submitFormRow">
                          <Col sm={6} className="submitFormCol">
                            <p className="form-check-label submitFormLabel">Your Name</p>
                          </Col>
                          <Col sm={6} className="submitFormCol">
                            <p className="form-check-label submitFormLabel">Your Email</p>
                          </Col>
                        </Row>
                        <Row className="submitFormRow">
                          <Col sm={6} className="submitFormCol">
                            <Input
                              type="text"
                              onChange={(e) => {
                                this.setState({ guestName: e.target.value });
                              }}
                              name="guestName"
                              placeholder="Enter your name"
                              className="remove-focus-outline submitFormInput"
                              maxLength={50}
                            />
                          </Col>
                          <Col sm={6} className="submitFormCol">
                            <Input
                              type="text"
                              onChange={(e) => {
                                this.setState({ guestEmail: e.target.value });
                              }}
                              name="guestEmail"
                              placeholder="Enter your email"
                              className="remove-focus-outline submitFormInput"
                              maxLength={50}
                            />
                            {this.state.guestEmail.length > 0
                              ? !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                                  this.state.guestEmail
                                ) && <span className="errorMessage">Please enter valid email</span>
                              : ''}
                          </Col>
                        </Row>
                        {metadata?.docRequestType !== 'sample_testing' ? (
                          <div className="documentsListWrapper">
                            {metadata?.requestedDocs?.map((record, docIndex) => {
                              const reqDocInd = docIndex;
                              return (
                                <div
                                  className="documentListItem"
                                  style={{
                                    backgroundColor: docIndex % 2 === 0 ? '#eee' : '#fff',
                                  }}
                                  key={reqDocInd}
                                >
                                  <div className="titleWrapper">
                                    <p>{record?.label}</p>
                                    <img
                                      src="images/Add-plan.png"
                                      alt=""
                                      onClick={() =>
                                        record?.filesData?.length > 0 && this.addFilesData(docIndex)
                                      }
                                    />
                                  </div>
                                  <div
                                    className="actionIconsWrapper"
                                    onDrop={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();

                                      const { files } = e.dataTransfer;

                                      if (files?.length) {
                                        this.updateFilesData(
                                          {
                                            target: { files: [...files] },
                                          },
                                          docIndex
                                        );
                                      }
                                    }}
                                    onDragOver={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    }}
                                  >
                                    {record?.filesData?.length > 0 ? (
                                      record?.filesData?.map((file, fileIndex) => {
                                        const fileInd = fileIndex;
                                        return (
                                          <div className="actionIconsSection" key={fileInd}>
                                            <p>{this.getFileDisplayName(file?.Key)}</p>
                                            <div className="uploadInput">
                                              <img
                                                src="images/Upload.png"
                                                alt="upload"
                                                title="Upload"
                                                className={
                                                  file?.Key ? 'uploadIconAlt' : 'uploadIcon'
                                                }
                                                onClick={() => {
                                                  if (!file?.Key) {
                                                    document
                                                      .getElementById('uploadFile' + docIndex)
                                                      .click();
                                                  }
                                                }}
                                              />
                                              <input
                                                type="file"
                                                style={{
                                                  visibility: 'hidden',
                                                }}
                                                id={'uploadFile' + docIndex}
                                                onChange={(e) => {
                                                  this.updateFilesData(e, docIndex);
                                                }}
                                              />
                                              {file.Key && (
                                                <img
                                                  className="deleteIcon"
                                                  src="images/deleteIcon.svg"
                                                  alt="Delete"
                                                  title="Delete"
                                                  onClick={() =>
                                                    this.handleDocDelete(file, docIndex)
                                                  }
                                                />
                                              )}
                                            </div>
                                          </div>
                                        );
                                      })
                                    ) : (
                                      <div className="actionIconsSection">
                                        <div className="uploadInput">
                                          <img
                                            src="images/Upload.png"
                                            alt="upload"
                                            title="Upload"
                                            className="uploadIcon"
                                            onClick={() => {
                                              document
                                                .getElementById('uploadFile' + docIndex)
                                                .click();
                                            }}
                                          />
                                          <input
                                            type="file"
                                            style={{
                                              visibility: 'hidden',
                                            }}
                                            id={'uploadFile' + docIndex}
                                            multiple={false}
                                            onChange={(e) => {
                                              this.updateFilesData(e, docIndex);
                                            }}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          Object.keys(sampleTestingDocsObj)?.map((attrKey) => {
                            const auditTestData = sampleTestingDocsObj[attrKey];
                            const renderRequestedDocs = requestedDocs.filter(
                              (reqDoc) =>
                                reqDoc?.['attributes'] &&
                                Object.keys(reqDoc['attributes']).includes(attrKey) &&
                                reqDoc['documentType'] ==
                                  sampleTestingDocsObj[attrKey]['documentType']
                            );
                            return (
                              renderRequestedDocs.length > 0 && (
                                <div className="sampleTestingWrapper">
                                  <div className="sampleTestingDocName">
                                    <p>{auditTestData.displayName}</p>
                                    <div
                                      className="descText"
                                      dangerouslySetInnerHTML={{
                                        __html: auditTestData.uac_text,
                                      }}
                                    ></div>
                                  </div>
                                  <div className="sampleTestingHead">
                                    <p>Upload document(s)</p>
                                  </div>
                                  <div className="participantsWrapper">
                                    {renderRequestedDocs.map((reqDoc, newDocIndex) => {
                                      const docIndex = metadata?.requestedDocs.findIndex(
                                        (obj) =>
                                          obj['value'] === reqDoc['value'] &&
                                          obj['documentType'] === reqDoc['documentType']
                                      );
                                      const key = docIndex;
                                      return (
                                        <div className="sampleTestingDocs" key={key}>
                                          <div
                                            className="STdocumentListItem"
                                            style={{
                                              backgroundColor:
                                                newDocIndex % 2 === 0 ? '#eee' : '#fff',
                                            }}
                                          >
                                            <div className="STtitleWrapper">
                                              <div className="STLabelSection">
                                                <p>
                                                  {reqDoc.label}
                                                  {!this.state.participantShortId && (
                                                    <span className="STLabelEmailSpan">
                                                      <a
                                                        href={
                                                          'mailto:' +
                                                          '' +
                                                          '?subject=' +
                                                          encodeURIComponent(
                                                            this.createSubject(
                                                              sampleTestingDocsObj[attrKey]
                                                                .displayName,
                                                              reqDoc.label
                                                            )
                                                          ) +
                                                          '&body=' +
                                                          encodeURIComponent(
                                                            this.createMailBody(
                                                              sampleTestingDocsObj[attrKey]
                                                                .displayName,
                                                              reqDoc.label,
                                                              '',
                                                              reqDoc.shortId
                                                            )
                                                          )
                                                        }
                                                      >
                                                        Send email to participant
                                                      </a>
                                                    </span>
                                                  )}
                                                </p>
                                                <img
                                                  src="images/Add-plan.png"
                                                  alt=""
                                                  onClick={() =>
                                                    reqDoc?.filesData?.length > 0 &&
                                                    this.addFilesData(docIndex)
                                                  }
                                                />
                                              </div>
                                              <div
                                                className="STactionIconsWrapper"
                                                onDrop={(e) => {
                                                  e.preventDefault();
                                                  e.stopPropagation();

                                                  const { files } = e.dataTransfer;

                                                  if (files?.length) {
                                                    this.updateFilesData(
                                                      {
                                                        target: {
                                                          files: [...files],
                                                        },
                                                      },
                                                      docIndex
                                                    );
                                                  }
                                                }}
                                                onDragOver={(e) => {
                                                  e.preventDefault();
                                                  e.stopPropagation();
                                                }}
                                              >
                                                {reqDoc?.filesData?.length > 0 ? (
                                                  reqDoc?.filesData?.map((file, fileIndex) => {
                                                    const fileInd = fileIndex;
                                                    return (
                                                      <div
                                                        className="STactionIconsSection"
                                                        key={fileInd}
                                                      >
                                                        <p>{this.getFileDisplayName(file?.Key)}</p>
                                                        <div className="STuploadInput">
                                                          <img
                                                            src="images/Upload.png"
                                                            alt="upload"
                                                            title="Upload"
                                                            className={
                                                              file?.Key
                                                                ? 'uploadIconAlt'
                                                                : 'uploadIcon'
                                                            }
                                                            onClick={() => {
                                                              if (!file?.Key) {
                                                                document
                                                                  .getElementById(
                                                                    'uploadFile' + docIndex
                                                                  )
                                                                  .click();
                                                              }
                                                            }}
                                                          />
                                                          <input
                                                            type="file"
                                                            style={{
                                                              visibility: 'hidden',
                                                            }}
                                                            id={'uploadFile' + docIndex}
                                                            onChange={(e) => {
                                                              this.updateFilesData(e, docIndex);
                                                            }}
                                                          />
                                                          <img
                                                            className="deleteIcon"
                                                            src="images/deleteIcon.svg"
                                                            alt="Delete"
                                                            title="Delete"
                                                            style={{
                                                              visibility: file?.Key
                                                                ? 'visible'
                                                                : 'hidden',
                                                            }}
                                                            onClick={() =>
                                                              this.handleDocDelete(file, docIndex)
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                    );
                                                  })
                                                ) : (
                                                  <div
                                                    className="STactionIconsSection"
                                                    style={{
                                                      justifyContent: 'flex-end',
                                                    }}
                                                  >
                                                    <div className="STuploadInput">
                                                      <img
                                                        src="images/Upload.png"
                                                        alt="upload"
                                                        title="Upload"
                                                        className="uploadIcon"
                                                        onClick={() => {
                                                          document
                                                            .getElementById('uploadFile' + docIndex)
                                                            .click();
                                                        }}
                                                      />
                                                      <input
                                                        type="file"
                                                        style={{
                                                          visibility: 'hidden',
                                                        }}
                                                        id={'uploadFile' + docIndex}
                                                        multiple={false}
                                                        onChange={(e) => {
                                                          this.updateFilesData(e, docIndex);
                                                        }}
                                                      />
                                                      <img
                                                        className="deleteIcon"
                                                        src="images/deleteIcon.svg"
                                                        alt="Delete"
                                                        title="Delete"
                                                        style={{
                                                          visibility: 'hidden',
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )
                            );
                          })
                        )}
                        <Row>
                          <Col sm={7}>
                            <p className="form-check-label submitFormLabel">
                              Message {'(optional):'}
                            </p>
                            <RichTextEditorComponent
                              ref={(richtexteditor) => {
                                this.rteUpdateObj = richtexteditor;
                              }}
                              toolbarSettings={this.toolbarSettings}
                              value={guestMessage}
                              change={() => {
                                this.setState({
                                  guestMessage: this.rteUpdateObj.value,
                                });
                              }}
                            >
                              <Inject
                                services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar, Table]}
                              />
                            </RichTextEditorComponent>
                          </Col>
                        </Row>
                        <div className="submitButtonWrapper">
                          <Button onClick={() => this.saveNewAttachment()}>Submit</Button>
                          <p
                            style={{
                              color: 'tomato',
                              marginTop: '10px',
                            }}
                          >
                            {errorMessage}
                          </p>
                        </div>
                      </div>
                      {/* </div> */}
                    </div>
                  ) : (
                    <div className={'responseMessageCss'}>
                      <div className={'responseMessageDiv'}>
                        <img src={'images/successResponse.svg'} alt="img" />
                        <h3 style={{ textAlign: 'center' }}></h3>
                      </div>
                      <div
                        className="uploadMsgSuccessWrapper"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <div
                          className="uploadMsgSuccess"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            justifyContent: 'center',
                          }}
                        >
                          <p className="uploadMsgDefaultText">
                            All the documents for this request have been received. NFAR. <br />
                            <br />
                            If you need to submit fresh set of documents, please visit{' '}
                            <a href="https://autire.ai" target="_blank" rel="noreferrer">
                              https://autire.ai
                            </a>{' '}
                            or contact your plan auditor {metadata.routingInfo.auditorEmail} to
                            raise another document request !!
                            <br />
                            <br />
                            Thank you.
                          </p>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div
                    className={
                      response.isBrokenLink ? 'responseMessageCssAlt' : 'responseMessageCss'
                    }
                  >
                    <div
                      className={
                        response.isBrokenLink ? 'responseMessageDivAlt' : 'responseMessageDiv'
                      }
                    >
                      <img
                        src={
                          response.isBrokenLink
                            ? 'images/uploadErrorIcon.svg'
                            : response.type == 0
                              ? 'images/failedResponse.svg'
                              : 'images/successResponse.svg'
                        }
                        alt="img"
                      />
                      <h3 style={{ textAlign: 'center' }}>{response.title}</h3>
                    </div>
                    <div className="uploadMsgSuccessWrapper">{response.message}</div>
                  </div>
                )}
              </div>
            </form>
          )}
        </div>
      </div>
    );
  }
}

export default Submit;
